import { useEffect, useState } from 'react';
import { LocalDataTrackPublication, Participant, RemoteParticipant, RemoteTrack } from 'twilio-video';
import useVideoContext from '../useVideoContext/useVideoContext';
import { useAppState } from '../../state';

export default function useRaisedHand(participant: Participant) {
  const [isRaisedHandRemote, setIsRaisedHandRemote] = useState(false);
  const { room } = useVideoContext();
  const current_participant = room?.participants?.get(participant.sid);
  const [tracks, setTracks] = useState<RemoteTrack[]>([]);
  const { isRaisedHand, setIsRaisedHand } = useAppState();

  useEffect(() => {
    if (room) {
      const participantConnected = (participant: RemoteParticipant) => {
        const dataTracks = Array.from(room?.localParticipant?.dataTracks.values() ?? []) as LocalDataTrackPublication[];
        if (isRaisedHand) {
          setTimeout(
            () =>
              dataTracks.forEach(pub => {
                pub?.track.send(
                  JSON.stringify({
                    type: 'raise-hand',
                    value: isRaisedHand,
                    participantSid: room?.localParticipant?.sid,
                  })
                );
              }),
            1000
          );
        }
      };

      room.on('participantConnected', participantConnected);
      return () => {
        room.off('participantConnected', participantConnected);
      };
    }
  }, [room, isRaisedHand]);

  useEffect(() => {
    if (!current_participant) return;
    const subscribedTracks = Array.from(current_participant!.dataTracks.values())
      .filter(trackPublication => trackPublication.track !== null)
      .map(trackPublication => trackPublication.track!);

    setTracks(subscribedTracks);
    const handleTrackSubscribed = (track: RemoteTrack) => {
      if (track.kind === 'data') {
        track.on('message', (message: string) => {
          let data: any;
          data = JSON.parse(message);
          if ((participant.sid === data.participantSid || data.participantSid === '*') && data.type === 'raise-hand') {
            setIsRaisedHandRemote(data.value);
            if (data.participantSid === '*') {
              setIsRaisedHandRemote(data.value);
              setIsRaisedHand(false);
            }
          }
        });
      }
      setTracks(prevTracks => [...prevTracks, track]);
    };
    const handleTrackUnsubscribed = (track: RemoteTrack) => {
      if (track.kind === 'data') {
        track.off('message', () => {});
      }
      setTracks(prevTracks => prevTracks.filter(t => t !== track));
    };

    current_participant!.on('trackSubscribed', handleTrackSubscribed);
    current_participant!.on('trackUnsubscribed', handleTrackUnsubscribed);
    return () => {
      current_participant!.off('trackSubscribed', handleTrackSubscribed);
      current_participant!.off('trackUnsubscribed', handleTrackUnsubscribed);
    };
  }, [current_participant]);

  return isRaisedHandRemote;
}
